export const roasMap = {
  'cards-itau-latampass-black': 40.05,
  'cards-itau-tudoazul-platinum': 27.47,
  'cards-santander-smiles-gold': 25.13,
  'cards-santander-aadvantage-platinum': 23.66,
  'cards-santander-unique': 23.49,
  'cards-santander-elite': 22.42,
  'cards-santander-free': 21.45,
  'cards-santander-smiles-platinum': 21.29,
  'cards-neon': 10.89,
  'cards-caixa-elo-mais': 8.69,
  'cards-itau-tudoazul-skyline': 7.82,
  'cards-itau-uniclass-signature': 6.24,
  'account-itau-pf-uniclass': 6.04,
  'cards-caixa-visa-platinum': 5.77,
  'cards-caixa-visa-infinite': 4.89,
  'loans-zippi-ep': 2.75,
  'cards-bancodobrasil-ourocardfacil': 2.73,
  'cards-itau-platinum': 2.18,
  'cards-caixa-visa-gold': 2.18,
  'collections-acordocerto': 1.96,
  'cards-itau-passai-gold': 1.57,
  'account-pagbank': 1.19,
  'cards-caixa-elo-grafite': 0.76,
  'cards-carrefour': 0.34,
  'loans-blipay-ep': 0.31,
  'loans-jbcred-ep': 0.07,
  'cards-c6-all': 0.04,
  'loans-simplic-ep': 0.03,
  'loans-facio-ep': 0.03,
  'loans-noverde-ep': 0.03,
  'account-picpay': 0.02,
  'loans-juvo-ep': 0.0,
  'cards-itau-latampass-platinum': 0.0,
  'cards-willbank': 0.0,
  'loans-upp-fgts': 0.0,
  'cards-itau-pao-de-acucar-black': 0.0,
  'loans-supersim-ep': 0.0,
  'cards-itau-click-platinum': 0.0,
  'cards-itau-latampass-internacional': 0.0,
  'cards-itau-tudoazul-gold': 0.0,
  'loans-jeitto-ep': 0.0,
  'cards-itau-ias-platinum': 0.0,
  'cards-brasilcard': 0.0,
  'loans-bmg-inss': 0.0,
  'cards-itau-tudoazul-infinite': 0.0,
  'cards-caixa-elo-nanquim': 0.0,
  'cards-itau-playersbank': 0.0,
  'cards-portoseguro-portobank-internacional-testeslug': 0.0,
  'cards-itau-latampass-gold': 0.0,
  'cards-itau-polishop-platinum': 0.0,
  'cards-itau-vivo-platinum': 0.0,
  'cards-itau-personnalite-black': 0.0,
  'cards-recargapay': 0.0,
  'cards-itau-vivo-gold': 0.0,
  'cards-santander-all': 0.0,
};
